/**
 * Geometry for the F.I.R.E. flame, on a 24x24 viewBox so it drops into Tabler
 * icon slots without layout shift.
 *
 * This is Tabler's own `flame-filled` glyph (MIT), used as-is. FireIcon mirrors
 * it horizontally at render time so the curl reads on the left, matching the
 * client's halftone mark. The mirror is a transform rather than flipped
 * coordinates: the path is ~20 relative béziers, and rewriting them by hand
 * buys nothing over letting the renderer do it.
 */
export const FLAME_PATH =
  'M10 2c0 -.88 1.056 -1.331 1.692 -.722c1.958 1.876 3.096 5.995 1.75 9.12l-.08 .174l.012 .003c.625 .133 1.203 -.43 2.303 -2.173l.14 -.224a1 1 0 0 1 1.582 -.153c1.334 1.435 2.601 4.377 2.601 6.27c0 4.265 -3.591 7.705 -8 7.705s-8 -3.44 -8 -7.706c0 -2.252 1.022 -4.716 2.632 -6.301l.605 -.589c.241 -.236 .434 -.43 .618 -.624c1.43 -1.512 2.145 -2.924 2.145 -4.78';

/** Horizontal mirror about the viewBox centre line. */
export const FLAME_MIRROR = 'translate(24 0) scale(-1 1)';
